import qs from 'qs'
import { router }  from './router'
import store  from './store'

//全局路由前置守卫
router.beforeEach((to, from, next) => {
  if(to.meta &&　to.meta.noAuth ){
    next()
  }else{
    if(store.state.vuex_token){
      return next()
    }else{
      next({ path: '/pages/login/login', query: { redirect: to.fullPath,back:!to.meta.isTab } })
    }
  }
})
// 全局路由后置守卫
router.afterEach((to, from) => {})
